import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useForm } from '../../../hooks/useForm'
import { ApiUrl } from '../../../services/ApiRest';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';

export const IncomeOfDay = () => {
    const today = new Date().toISOString().split("T")[0];
    const [dateNow, setDateNow] = useState(today);
    const [data, setdata] = useState([]);
    const [totalDailyIncome, setTotalDailyIncome] = useState(0);
    const [totalSum, setTotalSum] = useState(0);
    const [incomeId, setIncomeId] = useState();
    const [incomeDeleteId, setIncomeDeleteId] = useState();
    const [buttonDisabled, setButtonDisabled] = useState(true);
    const toastId = React.useRef(null);
    const [formD, setformD] = useState({
        description: '',
        total_loan: '0.00',
        date_now: dateNow,
        state: 1,
        type_credit: '',
        credit_id: null, // Si es necesario
    });

    const dataList = async () => {
        try {
            const response = await axios.get(ApiUrl + `daily-incomes-list`);
            const responseData = response.data;
            setdata(responseData);
            // Calcular la suma total - Egresos
            const totalValueIncomes = responseData
                .filter(item => item.type_credit === "I") // Filtra solo los egresos
                .reduce((acc, item) => acc + parseFloat(item.total_loan || 0), 0); // Suma los valores
            setTotalDailyIncome(totalValueIncomes);
            // Sumatoria Total tanyo de Mermas y Egresos
            const totalSumIncome = responseData.reduce((acc, item) => acc + parseFloat(item.total_loan || 0), 0);
            setTotalSum(totalSumIncome);
            const script = document.createElement("script");
            script.src = `/assets/dataTable/dataTable.js`;
            script.async = true;
            document.body.appendChild(script);
        } catch (error) {
            console.error(error);
        }
    };

    const onSubmit = async (event) => {
        event.preventDefault();
        setButtonDisabled(true);
        notify();
        const f = new FormData();
        f.append("description", formD.description);
        f.append("type_credit", 'I');
        f.append("total_loan", formD.total_loan);
        f.append("date_now", dateNow);
        f.append("status", 1);
        f.append("state", 11);
        await axios.post(ApiUrl + 'daily-incomes-add', f)
            .then(response => {
                var resp = response.data;
                if (resp.success) {
                    toast.success("Información agregada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    deleteTable();
                    dataList();
                    setformD({
                        description: '',
                        total_value: '',
                    });
                } else {
                    toast.error("La información no se ha agregado", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            })
            .catch(e => {
                toast.error("" + e + "!", { position: toast.POSITION.BOTTOM_RIGHT });
            })
            .finally(() => {
                setButtonDisabled(false); // Habilitar el botón después de que la solicitud haya finalizado
            });
    }

    const onSubmitUpdate = async (event) => {
        event.preventDefault();
        setButtonDisabled(true);
        notify();
        const f = new FormData();
        f.append("description", formD.description);
        f.append("total_loan", formD.total_loan);
        await axios.post(ApiUrl + 'daily-incomes-update/' + incomeId, f)
            .then(response => {
                var resp = response.data;
                if (resp.success) {
                    toast.success("Información actualizada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
                    dataList();
                    deleteTable();
                } else {
                    toast.error("Información no actualizada", { position: toast.POSITION.BOTTOM_RIGHT });
                }
            })
            .catch(e => {
                toast.error("" + e + "  !", { position: toast.POSITION.BOTTOM_RIGHT });
            })
            .finally(() => {
                setButtonDisabled(false);
            });
    }

    const deleteIncome = async (incomeDeleteId) => {
        try {
            const response = await axios.post(ApiUrl + `daily-incomes-delete/${incomeDeleteId}`);
            const resp = response.data;
            if (resp.success === true) {
                dataList();
                deleteTable();
                toast.success("Información eliminada exitosamente", { position: toast.POSITION.BOTTOM_RIGHT });
            } else {
                toast.error("Información no eliminada", { position: toast.POSITION.BOTTOM_RIGHT });
            }
        } catch (error) {
            console.log(error);
            toast.error("" + error + "!", { position: toast.POSITION.BOTTOM_RIGHT });
        }
    }

    const notify = () => toastId.current = toast("Enviando Datos...", { autoClose: true, type: toast.TYPE.INFO, position: toast.POSITION.BOTTOM_RIGHT });

    const deleteTable = () => {
        const script1 = document.createElement("script");
        script1.src = `/assets/dataTable/datatable-destroy.js`;
        script1.async = true;
        document.body.appendChild(script1);
    }

    const onInputChange = ({ target }) => {
        const { name, value } = target;
        setformD({
            ...formD,
            [name]: value
        })
    }

    useEffect(() => {
        dataList();
    }, []);

    return (
        <div>
            <div className='row'>
                <div className='col-12 '>
                    <div className="card">
                        <div className="card-header">
                            <div className="row align-items-center">
                                <div className="col-12 col-md-4 text-md-start">
                                    <b> INGRESOS DIARIOS</b>
                                </div>
                                <div className="col-12 col-md-4 text-center">
                                    <b> HOY: {today} </b>
                                </div>
                                <div className="col-12 col-md-4 d-flex flex-column flex-md-row justify-content-md-end gap-2 mt-2 mt-md-0">
                                    <button className="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#addIngreso">
                                        <b>AGREGAR INGRESO</b> <i className="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <br />
                        <div className="row text-center">
                            <div className="col-12 col-md-12 mb-12 mb-md-0">
                                <h5><b>TOTAL INGRESOS DIARIOS:</b> {totalSum.toFixed(2)}</h5>
                            </div>
                        </div>
                        <br />
                        <div className="card-body table-responsive">
                            <table className="table table-hover" id="dataTable">
                                <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Descripción</th>
                                        <th>Tipo</th>
                                        <th>Valor total</th>
                                        <th>Estado de pago</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {Array.isArray(data) &&
                                        data.map((item, index) => (
                                            <tr key={item.credit_id}>
                                                <td>{index + 1}</td>
                                                <td>{item.type_credit === 'I' ? item.description : `${item.client_name} - ${item.description}`}</td>
                                                <td>{item.type_credit === 'I' ? 'Ingresos' : 'Deudas cobradas'}</td>
                                                <td>{Number(item.total_loan).toFixed(2)}</td>
                                                <td>
                                                    <p className={`${item.status_description == 'Pagado' ? 'badge rounded-pill bg-success .large-text' : ''}`}>
                                                        {item.status_description}
                                                    </p>
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-outline-primary"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#editIngreso"
                                                        onClick={() => {
                                                            setformD({
                                                                description: item.description || "",
                                                                total_loan: item.total_loan || "",
                                                            });
                                                            setIncomeId(item.credit_id);
                                                        }}
                                                    >
                                                        <i className="fa fa-edit"></i>
                                                    </button>

                                                    <button
                                                        className="btn btn-outline-danger"
                                                        data-bs-toggle="modal"
                                                        data-bs-target="#deleteIngreso"
                                                        onClick={() => {
                                                            setIncomeDeleteId(item.credit_id);
                                                        }}
                                                    >
                                                        <i className="fas fa-trash-alt"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            {/* AGREGAR INGRESOS */}
            <div className="modal fade" id="addIngreso" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmit}>
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>AGREGAR NUEVO INGRESO</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-12'>
                                            <div className="">
                                                <label className="form-label">Descripción</label>
                                                <input type="text" name='description' className="form-control" value={formD.description || ""} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-12 col-md-12'>
                                            <div className="">
                                                <label className="form-label">Valor total</label>
                                                <input type="text" className="form-control" name="total_loan" value={formD.total_loan || ""} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" > Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* EDITAR INGRESOS */}
            <div className="modal fade" id="editIngreso" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <form onSubmit={onSubmitUpdate}>
                            <div className="modal-header">
                                <p className="modal-title" id="exampleModalLabel"><b>EDITAR INGRESO</b></p>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="card-body">
                                    <div className='row'>
                                        <div className='col-12 col-md-12'>
                                            <div className="">
                                                <label className="form-label">Descripción</label>
                                                <input type="text" name='description' className="form-control" value={formD.description || ""} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-12 col-md-4'>
                                            <div className="">
                                                <label className="form-label">Valor total</label>
                                                <input type="text" name='total_loan' className="form-control" value={formD.total_loan || ""} onChange={onInputChange} required ></input>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary" data-bs-dismiss="modal"> Aceptar</button> &nbsp;
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            {/* ELIMINAR INGRESO */}
            <div className="modal fade" id="deleteIngreso" tabIndex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="exampleModalLabel">ELIMINAR INGRESO</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            ¿Está seguro que desea eliminar?
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={() => deleteIncome(incomeDeleteId)}>Aceptar</button>
                            <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer theme="colored" />
        </div>
    )
}
